import React from 'react';
import { Link } from 'react-router-dom';
import favicon from '../favicon.ico';
import { FiUser } from "react-icons/fi";

const ForgotPassword = () => {
    return (
        <div className="min-h-screen bg-gradient-to-r from-blue-500 to-blue-500 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-md p-8 w-96">
                <div className="text-center mb-6">
                    <img 
                        src={favicon}
                        alt="Logo" 
                        className="mx-auto mb-4 w-16"
                    />
                    <h2 className="text-2xl font-bold text-gray-800">Forget Password</h2>
                    <p className="text-gray-600">Create New Password</p>
                </div>
                <form>
                    <div className="mb-4">
                        
                        <label htmlFor="username" className="block text-gray-700 font-medium">
                            Username
                        </label>
                        <div className="flex items-center border rounded-md bg-gray-50">
                            <span className="px-3 text-gray-500">
                                <i><FiUser className="text-gray-400" /></i> {/*<i className="fas fa-user"></i>*/}
                            </span>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder="Username"
                                className="flex-grow p-2 text-gray-800 outline-none"
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-gray-700 text-white py-2 px-4 rounded-md shadow-md font-medium transition duration-200"
                    >
                        Send Recovery Mail
                    </button>
                </form>
                <p className="text-center text-gray-600 text-sm mt-4">
                    By Clicking Send, you agree to our{' '}
                    <Link to="/terms_and_conditions" className="text-blue-600 hover:underline">
                        Terms & Conditions
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;
